import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import { H3 } from "../ui/typography";
import AvatarDetails from "@/components/avatar-detail";
import { container } from "../../styles/common-styles.module.css";
import { cn } from "@/utils";
import { blogCard } from "./blog.module.css";
import { Link } from "gatsby";
import { BlogPost } from "@/templates/blog-post";

interface BlogListProps extends React.HTMLProps<HTMLDivElement> {
  blogList: BlogPost[];
}

export interface BlogListType {
  allStrapiBlog: {
    nodes: BlogPost[];
  };
}

const BlogList: React.FC<BlogListProps> = ({ blogList, className }) => {
  return (
    <div className={`${container} ${cn("flex flex-wrap mt-16 md:mt-20", className)}`}>
      {blogList.map((blogPost: BlogPost, i: number) => (
        <div key={i} className={blogCard}>
          <Link to={`/blog/${blogPost.slug.slug}`} className="group">
            <div className="overflow-hidden rounded-2xl">
              <GatsbyImage
                image={blogPost.heroImage.localFile.childImageSharp.gatsbyImageData}
                alt={blogPost.heroImage.alternativeText}
                className="block group-hover:scale-125 transition w-full h-96"
              />
            </div>
            <H3 className="text-dark mt-6 group-hover:text-primary">{blogPost.title}</H3>
            <AvatarDetails
              className="mt-6 md:mt-8 mb-4"
              avatar={blogPost.author.avatar.localFile.childImageSharp.gatsbyImageData}
              altText={blogPost.author.avatar.alternativeText}
              name={blogPost.author.name}
              subText={`${blogPost.readTime} read`}
            />
          </Link>
        </div>
      ))}
    </div>
  );
};

export default BlogList;
